import type { FaireProductEntity } from "../../entity_types/product";

export const p_sgc68y9g72: FaireProductEntity = {
  token: "p_sgc68y9g72",
  type: "product",
  name: "Shimmer Sequin Purse",
  brandToken: "b_bt4s5wuad9",
  brandName: "Sparkle Sisters by Couture Clips",
  imageUrl:
    "https://cdn.faire.com/fastly/c2f704b405e19f251819dc971de8ae3728e3b63614d27c097d9e2db5feafbea0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f305492b162e24ea7c0cdc9744abd07e90cfff557bc016ebb47c9df1602510c7.jpeg",
    "https://cdn.faire.com/fastly/f41aec925fc80b978b608a6254dde720fbc702dc853555ac3198ef3dcc9c1f79.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "Introducing our Shimmer Sequin purse. This bag comes in blue, pink, and lavender. This is the perfect staple in any child's wardrobe with the fun twist of the pearl handle! Great for everyday wear, gifts, or special occasions! ",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:32.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
